import React from 'react'
import { StyledNotificationBadge } from './styles';
export const NotificationBadge = (props) => {
  const {value} = props;
  return (
    <StyledNotificationBadge className={`tma-${value?.toLowerCase()}`}>
        {value}
    </StyledNotificationBadge>
  )
}
